import axios from 'axios';

function getHeaders() {
  return { "Content-Type": "application/json" };

  // return {
  //   "Content-Type": "multipart/form-data",
  //   'Accept': "application/json",
  //   'type': "formData",
  // };
}
const instance = axios.create({
  baseURL: `${import.meta.env.VITE_API_BASE_URL}`,
  // timeout: 1000,
  headers: getHeaders(),
});

const instance2 = axios.create({
  baseURL: `${import.meta.env.VITE_API_BASE_URL2}`,
  // timeout: 1000,
  headers: getHeaders(),
});

instance.interceptors.request.use((config) => {
  if (
    [
      "/v1/user/easytogo-casino-amount-add",
      "/v1/wallet/doLoginAndLaunchEasyToCasino",
      "/v1/user/casino-amount-add",
      "/v1/wallet/doLoginAndLaunchGame",
      "/v1/wallet/login",
    ].includes(config?.url?.split("?")[0])
  ) {
    document.getElementById("loading").style.display = "flex";
  }
  const token = localStorage.getItem("token");
  if (!token) {
    return config;
  }
  config = {
    ...config,
    headers: { ...config.headers, Authorization: `Bearer ${token}` },
  };
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401 || status === 403) {
      localStorage.clear();
      window.location.reload();
      return Promise.reject(error);
    }

    // ✅ 404 → silent
    if (status === 404) {
      return {
        data: null,
        status: 404,
        statusText: "Not Found",
        headers: {},
        config: error.config,
      };
    }
if (status === 400) {
  // console.log("400 raw error.response.data:", error.response.data); // ← add this
  return {
    data: {
      ...error.response.data,
      message: error.response.data?.message || "Bad Request",
    },
    status: 400,
    statusText: "Bad Request",
    headers: error.response.headers,
    config: error.config,
  };
}

    return Promise.reject(error);
  }
);


function apiGet(url, params = {}) {
  return instance.get(url, { params });
}

function apiGet2(url, params = {}) {
  return instance2.get(url, { params });
}

function apiPost(url, body) {
  return instance.post(url, body);
}

function apiPut(url, body) {
  return instance.put(url, body);
}

function apiDelete(url) {
  return instance.delete(url);
}

export { getHeaders, apiGet, apiGet2, apiPost, apiPut, apiDelete };
